$(function () {
  var $form = $('#searchForm_schedule').find('form'); // フォームを取得
  var $routeSelect = $form.find('#searchForm_item_route'); // 路線のセレクトボックスを取得
  var $busstopSelect = $form.find('#searchForm_item_busstop'); // バス停のセレクトボックス
  deleteBusstopOptions($routeSelect, $busstopSelect);
  $routeSelect.on('change', function () {
    deleteBusstopOptions($(this), $busstopSelect);
  });
});

/* =========== バス停を消すの関数 =========== */
function deleteBusstopOptions ($select, $targetSelect) {
  var selectValue = $select.find('option:selected').val(); // 選択されたoptionのvalueを取得
  var $options = $targetSelect.find('option'); // ターゲットのoptionを取得

  if (selectValue != '') {
    // 選択されたoptionのvalueがターゲットのclassと同じだった時の処理
    $options.each(function () {
      var cls = $(this).attr('class');
      var flag = false;
      var clsArray = String(cls).split(' ');
      for (var i = 0, l = clsArray.length; i < l; i++) {
        if (clsArray[i] == selectValue) {
          flag = true;
          break;
        }
      }

      if (flag || cls == undefined) {
        if ($(this).parent().get(0).tagName == 'SPAN') {
          $(this).unwrap();
        }
      } else {
        if ($(this).parent().get(0).tagName == 'SELECT') {
          $(this).wrap('<span style ="display: none">');
        }
      }
    });
  } else {
    // 選択されたoptionのvalueがない時
    $options.each(function () {
      if ($(this).parent().get(0).tagName == 'SPAN') {
        $(this).unwrap();
      }
    });
  }
}
